<div class="l_flexbar l_flex-bottom-children l_flex-justify">
  <ng-container *ngIf="!isLoading; else skeleton">
    <ng-container *ngIf="hasResults">
      <ng-container *ngTemplateOutlet="resultsCount"></ng-container>
      <ng-container *ngTemplateOutlet="resultsSort"></ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- `Results/Endorsed #-20 of ####` header -->
<ng-template #resultsCount>
  <div class="l_flex-grow par">
    <h2
      class="par font-semibold header-text"
      [textContent]="headerText"
    ></h2>
    <span
      *ngIf="!hideCount"
      class="par par--small par--light_a font-medium results-range"
      [textContent]="resultsRange"
    ></span>
  </div>
</ng-template>

<!-- Sort dropdown -->
<ng-template #resultsSort>
  <div *ngIf="showSort" class="par par--small par--light_a font-bold">
    <dgx-menu
      class="sortby-filter--menu"
      [menuConfig]="menuConfig"
      placement="bottom-right"
      iconSize="small"
    >
      <button
        class="sort-button"
        type="button"
        attr.aria-label="{{ i18n.Core_SortBy }}: {{ sortButtonText }}"
        data-dgat="search-learnings-724"
      >
        {{ i18n.Core_SortBy }}
        <df-icon icon="chevron-down" size="small"></df-icon>
      </button>
    </dgx-menu>
  </div>
</ng-template>

<!-- Loading skeleton -->
<ng-template #skeleton>
  <div class="l_flex-grow" *ngIf="!showSearchLayoutRedesign">
    <div style="width: 10rem">
      <dgx-skeleton type="list" [rows]="1"></dgx-skeleton>
    </div>
  </div>
  <div>
    <div
      style="width: 10rem"
      *ngIf="!this.hideSort && !showSearchLayoutRedesign"
    >
      <dgx-skeleton type="list" [rows]="1"></dgx-skeleton>
    </div>
  </div>
</ng-template>
